<template>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    close-on-content-click
    :min-width="200"
    class="v-menu-canvas"
  >
    <template v-slot:activator="{ on }">
      <div class="jsPlumb-canvas-container" @contextmenu="show">
        <slot v-on="on"></slot>
      </div>
    </template>
    <v-list v-if="nodeClicked" dense> 
        <v-list-item v-for="(item, index) in items" :key="index" :disabled="shouldShowItem(item)" :style="{ opacity: shouldShowItem(item) ? 0.5 : 1 }">   
          <div>
            <v-list-item @click="callAction(item.action)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title >{{ item.title }}</v-list-item-title>
            </v-list-item>
          </div>    
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from "vuex";
import ModaleSavedNodes from "./ModaleSavedNodes.vue"

export default {
  props: {
    nodeClicked: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showMenu: false,
      showTemplate: false,
      x: 0,
      y: 0,
      newNodeX: 0,
      newNodeY: 0,
      items: [
        {
          title: "Coller",
          icon: "mdi-selection-multiple",
          action: "duplicateSelection",
          showState: true,
        },
        {
          title: "Add virgin node",
          icon: "mdi-plus",
          action: "createNode",
          showState: true,
        },
        {
          title: "Add start Node",
          icon: "mdi-plus",
          action: "createStartNode",
          showState: true,
        },
        {
          title: "Coller",
          icon: "mdi-selection-multiple",
          action: "duplicateSelection",
          showState: true,
        }
      ]
    };
  },
  components: {
    ModaleSavedNodes,
  },

  mounted (){
    this.checkStartNode()
    console.log('savedNodes : ', this.selectedSavedNodes)
  },

  computed : {
    selectedSavedNodes : {
      get() {
        const savednodes = [];
        this.getSkills({projectId: this.$route.params.id})
        .then((project) => {
          project.map((skill) => {
            this.getSavedNodes(skill._id)
              .then((savedNodes) => {
                const promises = savedNodes.map(node => {
                  savednodes.push(node);
                  this.items.push(            
                    {
                      title: node.name,
                      icon: "mdi-plus",
                      action: node,          
                    }
                  );
                })
                return Promise.all(promises);
              })
              .catch((err) => {
                console.log(err.message);
              })
          });
        })
        .catch((err) => {
            console.log(err.message);
        });
        return savednodes;
      }
    },
    createEmptyNode : {
      get() {
        return this.items[0];        
      }
    },
    createStartNode : {
      get() {
        return this.items[1];        
      }
    }
  },

  methods: {
    ...mapActions({
      createNode: "http/nodes/createNode",
      getNodes: "http/nodes/getNodes",
      updateNode: "http/nodes/updateNode",
      addNodeToCanvas: "canvas/addNode",
      getSavedNodes: "http/nodes/getSavedNodes",
      getSkills: "http/skills/get",
      cloneNode: 'http/nodes/cloneNode',
      duplicateLinks: 'http/links/duplicateLinks',
      createLink: "http/links/createLink",
    }),
    checkStartNode() {
      if (this.$route.params.skillId)
      this.getNodes(this.$route.params.skillId)
        .then((nodes) => {
          if(nodes.length > 0) {
            nodes.map((node)=> { 
              let anchors = node.anchors.map((anchor)=> anchor.name !== 'in' );
              if(anchors.every(item => item)) {
                this.items[1].showState = false
              }else {
                this.items[1].showState = true
              }
           })
          } else {
            this.items[1].showState = true
          }

        })
    },
    show(e) {
      e.preventDefault();
      // console.log(e);
      this.checkStartNode()
      if (this.showMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    // Function to find a new anchor based on value, name, and variable
    findNewAnchor(oldAnchor, newAnchorsMap) {
      return Array.from(newAnchorsMap.values()).find(newAnchor => {
        return (
          oldAnchor.value === newAnchor.value &&
          oldAnchor.name === newAnchor.name &&
          oldAnchor.variable === newAnchor.variable
        );
      });
    },
    async callAction(action) {
      const defaultAddNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
        startNode: false
      };

      const defaultAddStartNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
        startNode: true
      };

      if (action === "createNode") {
        this.createNode({
          skillId: this.$route.params.skillId,
          data: defaultAddNodeData,
          startNode: false
        }).then((data) => {
          return this.addNodeToCanvas(data);
        });
      } else if(action === "createStartNode"){
        this.createNode({
          skillId: this.$route.params.skillId,
          data: defaultAddStartNodeData,
        }).then((data) => {
          this.items[1].showState = false;
          return this.addNodeToCanvas(data);
        });

      } else if (action === "duplicateSelection") {
        // Retrieve the array of selected nodes from localStorage
        let selectedNodes = [];
        const storedNodes = localStorage.getItem('selectedNodes');
        const duplicateSelectionBool = localStorage.getItem("duplicateSelectionBool") || false;

        if (storedNodes) {
          try {
            selectedNodes = JSON.parse(storedNodes);
          } catch (error) {
            console.error('Error parsing stored nodes:', error);
          }
        }

        if (selectedNodes.length > 0) {
          const uniqueLinksSet = new Set();

          // Create a map of anchors using their IDs
          const anchorsMap = new Map();
          selectedNodes.forEach(element => {
            element.node.anchors.forEach(anchor => {
              anchorsMap.set(anchor._id, anchor);
            });
          });

          // Clone the first node and add it to the canvas
          let newNodes = [];
          const cloneAndAddToCanvas = async (element, position) => {
            const clonedNode = await this.cloneNode({ skillId: this.$route.params.skillId, idNode: element.nodeId, data: { position: position} })
              .then(data => {
                newNodes.push(data);
                data.position.x = this.newNodeX;
                data.position.y = this.newNodeY;
                return data;
              })
              .catch(error => {
                console.log("Error duplicating Node : ", element.node);
              });

            if (clonedNode) {
              this.addNodeToCanvas(clonedNode);

              // Get the anchors of the cloned node and add them to the anchorsMap
              clonedNode.anchors.forEach(anchor => {
                anchorsMap.set(anchor._id, anchor);
              });
            }
          };

          // Clone the first node
          await cloneAndAddToCanvas(selectedNodes[0], { x: this.newNodeX, y: this.newNodeY });
          if(selectedNodes.length === 1) {
            localStorage.removeItem("duplicateSelectionBool");
            localStorage.removeItem("selectedNodes");
            window.location.reload();
          }

          // Continue cloning for the rest of the nodes
          for (let i = 1; i < selectedNodes.length; i++) {
            await cloneAndAddToCanvas(selectedNodes[i], { x: this.newNodeX + (selectedNodes[i].node.position.x - selectedNodes[0].node.position.x), y: this.newNodeY + (selectedNodes[i].node.position.y - selectedNodes[0].node.position.y) });
          }

          // Log unique links for each node
          selectedNodes.forEach(element => {
            element.links.forEach(link => {
              const fromAnchor = anchorsMap.get(link.from);
              const toAnchor = anchorsMap.get(link.to);

              // Check if both fromAnchor and toAnchor exist
              if (fromAnchor && toAnchor) {
                const linkString = JSON.stringify({
                  from: fromAnchor,
                  to: toAnchor,
                });
                uniqueLinksSet.add(linkString);
              }
            });
          });

          const uniqueLinksArray = Array.from(uniqueLinksSet).map(linkString => JSON.parse(linkString));

          // Map old anchors to new anchors
          const newAnchorsMap = new Map();
          newNodes.forEach(node => {
            node.anchors.forEach(anchor => {
              newAnchorsMap.set(anchor._id, anchor);
            });
          });

          await this.duplicateLinks({newNodes: newNodes, uniqueLinksArray: uniqueLinksArray, selectedNodes: selectedNodes})
          .then(data => {
            data.forEach(async link => {
              await this.createLink({from: link.from[0]._id, to: link.to[0]._id}).then(data => {
                window.location.reload();
              })
              .catch(error => {
                console.log(error);
              })
            })
          })
          .catch(error => {
            console.log(error);
          })
        }

        localStorage.removeItem("duplicateSelectionBool");
        localStorage.removeItem("selectedNodes");

      } else {
        const clonnedNode = await this.cloneNode({ skillId: this.$route.params.skillId, idNode: action._id, data: { position: defaultAddStartNodeData.position } })
        if(clonnedNode) {
          await this.addNodeToCanvas(clonnedNode);
        }
        // .then((data) => {
        //   data.position.x = defaultAddNodeData.position.x;
        //   data.position.y = defaultAddNodeData.position.y;
        //   return data;
        // })
        // .then((data) => {
        //   this.updateNode({ skillId: this.$route.params.skillId, idNode: data._id, data: data })
        //   .then((data) => {
        //     return this.addNodeToCanvas(data);
        //   })
        // });
      }
    },
    shouldShowItem(item) {
      if (item.action === "duplicateSelection") {
        const selectedNodes = JSON.parse(localStorage.getItem("selectedNodes")) || [];

        return selectedNodes.length === 0;
      }
      // If showState is not defined or false, always show the item
      return false;
    },

  },
};
</script>

<style scoped>
.jsPlumb-canvas-container {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  outline: none;
  overflow: hidden;
  max-height: 100vh;
  max-width: 100vw;
}
</style>
